import Vue from 'vue';
import recipeIngredienceTransformer from '../../transformers/recipeIngredience';
import store from './../../store';

const success = (resolve, response) => {
  store.dispatch('updateRecipeIngredience', {
    recipeIngredience: recipeIngredienceTransformer.fetch(response.data),
    id: response.data.id,
  });
  resolve();
};

const failed = (errors, reject) => {
  reject(recipeIngredienceTransformer.fetch(errors));
};

export default (id, recipeIngredience) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`/production/recipe_ingredience/${id}`, recipeIngredienceTransformer.send(recipeIngredience))
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipeIngredience/update.js